import BaseLayout from './BaseLayout';
import './BaseLayouts.scss';

export default BaseLayout;
